import { PermissionLevel } from '@/client/custom-roles';
import React from 'react';
import styled, { css } from 'styled-components';

type PermissionPillProps = {
  label: string;
  level: PermissionLevel;
};

const Pill = styled.span<{ $level: PermissionLevel }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--xxxsmall-padding) var(--xsmall-padding);
  border-radius: var(--grand-border-radius);
  font-size: var(--xsmall-font-size);
  line-height: var(--xsmall-line-height);
  white-space: nowrap;

  ${({ $level }) =>
    $level === PermissionLevel.VIEW &&
    css`
      background-color: var(--blue-light);
      color: var(--blue-text);
      font-weight: var(--medium-font-weight);
    `}

  ${({ $level }) =>
    $level === PermissionLevel.EDIT &&
    css`
      background-color: var(--green-edit-bg);
      color: var(--green-status);
    `}

  ${({ $level }) =>
    $level === PermissionLevel.NONE &&
    css`
      background-color: var(--platinum-main);
      color: var(--gray-darkest);
    `}
`;

export const PermissionPill: React.FC<PermissionPillProps> = ({
  label,
  level,
}) => <Pill $level={level}>{label}</Pill>;
